import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

const Logout = () => {
  useEffect(() => {
    localStorage.removeItem("users");
    localStorage.removeItem("owner_avatar");
    localStorage.removeItem("token");
  }, []);

  return <Navigate to="/login" />;
};

export default Logout;
